var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOpenEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 12,
    viewBox: "0 0 23 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.67821C2.73064 2.58326 5.94937 0.407783 10.1069 0.0488057C15.1817 -0.389321 18.982 2.17488 22.466 5.62797C19.8462 8.6216 16.7414 10.7499 12.7525 11.2164C7.5026 11.8302 3.56985 9.23038 0 5.67821ZM7.22109 5.60945C7.20425 7.82702 8.95984 9.64324 11.1527 9.67636C13.3986 9.71032 15.2345 7.9261 15.246 5.6987C15.2572 3.4539 13.4649 1.62954 11.242 1.62309C9.04516 1.61691 7.23765 3.40927 7.22109 5.60945ZM1.40083 5.62825C3.41155 7.54046 5.55615 9.06871 8.2141 9.78273C6.91768 8.65612 6.18401 7.28729 6.20983 5.555C6.23593 3.81709 7.06223 2.48923 8.37913 1.4036C5.64007 2.0991 3.4079 3.57178 1.40083 5.62825ZM14.2286 1.49201C16.8994 3.67422 17.0589 7.59435 13.9311 9.99913C16.8122 9.21746 19.0738 7.73665 21.0635 5.68074C19.0516 3.75646 16.882 2.23018 14.2286 1.49201Z",
    fill: "#0F4C86"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6736 3.19061C11.0805 3.96862 11.0859 4.5715 11.6545 4.98297C12.2195 5.39162 12.7735 5.20105 13.3697 4.39356C14.0152 5.37282 13.8799 6.61843 13.0371 7.45539C12.1737 8.31284 10.8658 8.45261 9.85372 7.79556C8.83741 7.13571 8.42005 5.87157 8.84892 4.75338C9.29041 3.60263 10.3968 2.96803 11.6736 3.19061Z",
    fill: "#0F4C86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOpenEye);
export default __webpack_public_path__ + "static/media/IconOpenEye.e5a52af20af2b211cdca23f55e8b6345.svg";
export { ForwardRef as ReactComponent };